import { createAiChatHttpClient } from './httpClient';
import { chatbotAgentsPath } from './paths';
import { getAiChatApiBase } from '../config';
import { normalizeChatbotAgentRow } from './normalizeChatbotAgentRow';

/**
 * @typedef {{ id: string, name: string, displayName?: string }} ChatbotAgent
 */

/**
 * GET /chatbot/agents (relative to REACT_APP_AI_CHAT_API_BASE).
 * Returns [] when API base is unset or the HTTP client cannot be created.
 *
 * @returns {Promise<ChatbotAgent[]>}
 */
export async function fetchChatbotAgents() {
  if (!getAiChatApiBase()) {
    return [];
  }
  const client = createAiChatHttpClient();
  if (!client) {
    return [];
  }

  const { data } = await client.get(chatbotAgentsPath());
  const raw = Array.isArray(data)
    ? data
    : data && Array.isArray(data.data)
    ? data.data
    : [];

  return raw
    .map((row) => normalizeChatbotAgentRow(row))
    .filter(Boolean)
    .map((n) => ({
      id: n.id,
      name: n.name,
      displayName: n.displayName,
    }));
}
